// FamilyHistoryOfMentalHealthTable.jsx
import React from "react";
import { TextField, Button } from "@mui/material";

const FamilyHistoryOfMentalHealthTable = ({
  familyHistoryOfMentalHealth,
  setFamilyHistoryOfMentalHealth,
}) => {
  const handleChange = (index, field, value) => {
    setFamilyHistoryOfMentalHealth((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addRow = () => {
    setFamilyHistoryOfMentalHealth((prev) => [
      ...prev,
      { familyMember: "", difficultiesDiagnosis: "" },
    ]);
  };

  const removeRow = (index) => {
    setFamilyHistoryOfMentalHealth((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        style={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          paddingLeft: "10px",
          marginTop: "10px",
          marginRight: "10px",
          paddingTop: "5px",
          marginBottom: "10px",
        }}
      >
        {/* <Typography variant="h6" style={{ marginBottom: "10px" }}>
          Family History of Mental Health
        </Typography> */}
        <div style={{ marginTop: "10px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={styles.header}>Family Members</th>
                <th style={styles.header}>Difficulties / Diagnosis</th>
                <th style={styles.header}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {familyHistoryOfMentalHealth.map((entry, index) => (
                <tr key={index}>
                  <td style={styles.cell}>
                    <TextField
                      value={entry.familyMember}
                      onChange={(e) =>
                        handleChange(index, "familyMember", e.target.value)
                      }
                      fullWidth
                      placeholder="Family Member"
                    />
                  </td>
                  <td style={styles.cell}>
                    <TextField
                      value={entry.difficultiesDiagnosis}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "difficultiesDiagnosis",
                          e.target.value
                        )
                      }
                      fullWidth
                      placeholder="Difficulties / Diagnosis"
                    />
                  </td>
                  <td style={styles.cell}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => removeRow(index)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ marginTop: "10px" }}>
        <Button variant="outlined" onClick={addRow}>
          Add Row
        </Button>
      </div>
    </div>
  );
};

const styles = {
  header: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#f0f0f0",
  },
  cell: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
  },
};

export default FamilyHistoryOfMentalHealthTable;
